import { BaseTooltip } from './tooltip';
import { TooltipTrigger } from './tooltip-trigger';
import { TooltipContent } from './tooltip-content';
import { withAliases } from '../../../ui/utils/with-aliases';
export var Tooltip = withAliases(BaseTooltip, {
    Trigger: TooltipTrigger,
    Content: TooltipContent,
});
